import Vue from "vue";
import Vuex from "vuex";
import vuetify from "./plugins/vuetify";
import ElementUI from "element-ui";
import CKEditor from "@ckeditor/ckeditor5-vue";
//import 'element-ui/lib/theme-chalk/index.css';
import locale from "element-ui/lib/locale/lang/en";
import vueHeadful from "vue-headful";
import vueMoment from "vue-moment";
import ImageUploader from "vue-image-upload-resize";
import VueApexCharts from "vue-apexcharts";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import * as VueGoogleMaps from "vue2-google-maps";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import VueGmaps from "vue-gmaps";
import numFormat from "vue-filter-number-format";
import VImageInput from "vuetify-image-input";


import { googleMapApiKey } from "./utils/Constants";
import "./styles/element-variables.scss";
import "./styles/styles.scss";

Vue.config.productionTip = false;

import "./assets/js/fb-app.js";
import VueHtmlToPaper from "vue-html-to-paper";

const paperOptions = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://cdn.jsdelivr.net/npm/vuetify@1.x/dist/vuetify.min.css",
    "https://unpkg.com/element-ui/lib/theme-chalk/index.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
  ],
};

Vue.use(VueHtmlToPaper, paperOptions);

import VueSweetalert2 from "vue-sweetalert2";

// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);

/*
import { BootstrapVue } from 'bootstrap-vue'
Vue.use(BootstrapVue)
*/
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

Vue.component("apexchart", VueApexCharts);
Vue.use(Vuex);
Vue.use(ElementUI, { locale });
Vue.use(vueMoment);
Vue.use(ImageUploader);
Vue.use(CKEditor);

Vue.use(VueGoogleMaps, {
  load: {
    key: googleMapApiKey,
    libraries: "places,drawing",
  },
});

Vue.use(VueGmaps, {
  key: googleMapApiKey,
});

Vue.filter("numFormat", numFormat);

Vue.component(VImageInput.name, VImageInput);
Vue.component("vue-headful", vueHeadful);
Vue.component("GmapCluster", GmapCluster);

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
